<script>
import Vue from 'vue'

const regex = new RegExp('^(http|https)://', 'i')

export default Vue.extend({
    name: 'LinkCellRenderer',
    computed: {
        href () {
            const match = regex.test(this.link)
            return match ? this.link : `//${this.link}`
        },
    },
    created () {
        const { value } = this.params
        this.link = value
    },
    methods: {
        getValue () {
            return this.link
        },
    },
    render (h) {
        return h(
            'div',
            {
                class: 'LinkCellRenderer',
            },
            [
                h('a', {
                    attrs: {
                        href: this.href,
                        target: '_blank',
                    },
                }, this.link),
            ],
        )
    },
})
</script>
